import AxiosInstance from 'config/apiServiceApiGateway'

import { VendorDetailRequestInterface, PostVendorReviewDataType } from '../types/VendorManagement'

export const getVendorDetailRequest = (vendor_id: string) =>
  AxiosInstance.Get<{ data: VendorDetailRequestInterface; error: { status: boolean } }, true>({
    url: `/commercial/internal/:version/vendors/submissions/${vendor_id}`,
    version: 'v1',
  })

export const postVendorReviewAPI = (vendor_id: number | string, data: PostVendorReviewDataType) =>
  AxiosInstance.Post({
    url: `/commercial/internal/:version/vendors/submissions/${vendor_id}/review`,
    version: 'v1',
    data,
  })
